export const KUPI_API = "https://kowf8rdy6b.execute-api.us-east-1.amazonaws.com/api/";
export const FORMAT_MESSAGE = "формат";
export const REQUIRED_MESSAGE = "обязательно";
